module.exports = __webpack_public_path__ + "static/media/gtr.34bf3b6f.jpg";